import moment from 'moment';

export function dateComparator(date1, date2) {
  if (date1 === null && date2 === null) {
    return 0;
  }
  if (date1 === null) {
    return -1;
  }
  if (date2 === null) {
    return 1;
  }
  const m1 = moment(date1);
  const m2 = moment(date2);
  if (m1.isSame(m2, 'day')) {
    return 0;
  }
  return m1.isBefore(m2) ? 1 : -1;
}

export function minDateAggregation(date1, date2) {
  if (date1 === null && date2 === null) {
    return 0;
  }
  if (date1 === null) {
    return -1;
  }
  if (date2 === null) {
    return 1;
  }
  const m1 = moment(date1);
  const m2 = moment(date2);
  if (m1.isSame(m2, 'day')) {
    return 0;
  }
  return m1.isBefore(m2) ? 1 : -1;
}

export function maxDateAggregation(date1, date2) {
  if (date1 === null && date2 === null) {
    return 0;
  }
  if (date1 === null) {
    return -1;
  }
  if (date2 === null) {
    return 1;
  }
  const m1 = moment(date1);
  const m2 = moment(date2);
  if (m1.isSame(m2, 'day')) {
    return 0;
  }
  return m1.isBefore(m2) ? 1 : -1;
}


export function stringComparator(str1, str2) {
  const isNull1 = str1 === null || str1 === undefined;
  const isNull2 = str2 === null || str2 === undefined;
  if (isNull1 && isNull2) {
    return 0;
  }
  if (isNull1) {
    return -1;
  }
  if (isNull2) {
    return 1;
  }
  return str1.localeCompare(str2, 'en', { sensitivity: 'base' });
}

